import { Box, BoxProps } from "@xcorejs/ui";

import { FC } from "react";
import styled from "styled-components";

export type LeftMenuProps = BoxProps;

const LeftMenuStyle = styled(Box)`
  width: 100%;

  a {
    display: flex;
    font-weight: 600;
    border-bottom: 0;
    padding-bottom: 1rem;
    
    > * {
      transition: border 300ms;
      border-bottom: .1rem solid #e00034;
    }
    
    &:hover {
      border-bottom: 0;
      
      > * {
        border-color: transparent;
      }
    }
    
    &.active {
      align-items: center;
      justify-content: space-between;
      
      > * {
        border-color: transparent;
        color: #1E1E1E;
      }
    }
    
    @media screen and (min-width: 64em) {
      padding-bottom: 0;
      
      &.active {
        
        &:after {
           content: "";
           width: 3rem;
           height: .2rem;
           background-color: #DEE1E5;
        }
      }
    }
  }
`;

const LeftMenu: FC<LeftMenuProps> = (
  {
    children,
    ...props
  }
) => {
  return (
    <LeftMenuStyle {...props}>
      {children}
    </LeftMenuStyle>
  );
};

LeftMenu.displayName = "LeftMenu";

export default LeftMenu;
